module.exports = __webpack_public_path__ + "img/circle-i.ace89fee.svg";